<template>
    <div class="results-page">
        <a class="skip-main" href="#main">Skip to main content</a>
        <b-sidebar @shown="sidebarIsOpen = true" @hidden="sidebarIsOpen = false" id="sidebar-right" width="460px" right shadow no-header bg-variant="secondary" backdrop>
            <div class="row p-4">
                <div class="col-12">
                    <h2 class="text-white d-inline-block">Edit your Journey</h2>
                    <a href="javascript:void(0)" v-b-toggle.sidebar-right class="text-white float-right c-pointer">Cancel</a>
                </div>
                <div class="col-12">
                    <edit-journey v-if="sidebarIsOpen"></edit-journey>
                </div>
            </div>
        </b-sidebar>
        <b-sidebar @shown="sidebarIsOpen = true" @hidden="sidebarIsOpen = false" id="sidebar-filter" width="420px" right shadow no-header bg-variant="white" backdrop>
            <refine-journey></refine-journey>
        </b-sidebar>
        <div class="journey-results-queery-container py-4">
            <div class="container">
                <div class="row">
                    <div class="d-none d-md-block col-lg-3">
                        <h1 class="text-white">Journey results</h1>
                    </div>
                    <div class="col-lg-9 col-sm-12">
                        <div class="d-flex search-query justify-content-between  mt-1" v-if="searchQuery">
                            <div class="location-container flex-fill px-3 overflow-hidden search-queery-input-container no-wrap">
                                {{ searchQuery.origin_address }}
                            </div>
                            <div class="svg-wrapper-ios-fix text-center py-2 py-md-0">
                                <svg-icon name="from-to-arrows-small-icon" :color="brand==='kcc' ? 'black' : 'white'" class="mt-2 mx-3" width="15" />
                            </div>
                            <div class="location-container flex-fill px-3 overflow-hidden search-queery-input-container mr-md-3">
                                {{ searchQuery.destination_address }}
                            </div>
                            <a v-if="!enableMultipleJourneyTypeFilter" href="javascript:void(0)" class="text-white d-block text-center mt-md-0 mt-3" v-b-toggle.sidebar-right>
                                <div class="mx-auto results-edit-btn c-pointer mt-2">
                                Edit
                                </div>
                            </a>
                            <div v-else class="d-md-flex mt-4 mt-md-0">
                                <button class="btn btn-border mr-2 w-100-mobile" style="width: 111px;" v-b-toggle.sidebar-right>
                                    Edit journey
                                </button>
                                <button class="btn btn-border w-100-mobile mt-3 mt-md-0" style="width: 149px;" v-b-toggle.sidebar-filter>
                                    <svg-icon id="refine-icon" class="mr-2" name="sort" width="20" height="auto"></svg-icon>
                                    <span>Refine results</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!enableMultipleJourneyTypeFilter" class="bg-light py-3 float-left w-100 mb-4">
            <!-- if its in medium or smaller screen hide the sort buttons-->
            <div class="container d-none d-lg-block ">
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-1">
                        <div class="input-group d-flex">
                            <div v-if="brand === 'nhs'" style="display: none" class="input-group-prepend">
                                <label class="input-group-text bg-white filter-box" for="result-filter">Showing</label>
                            </div>
                            <div v-else class="input-group-prepend">
                                <label class="input-group-text bg-white filter-box" for="result-filter">Showing</label>
                            </div>
                            <select class="d-inline-block flex-grow-1" v-model="resultFilter.selected" id="result-filter">
                                <option v-for="(option, index) in resultFilters" :key="index" :value="option.stage">
                                    <span>{{ option.name }}</span>
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-1">
                        <div class="input-group d-flex">
                            <div v-if="brand === 'nhs'" style="display:none;" class="input-group-prepend">
                                <label class="input-group-text bg-white filter-box" for="sort-filter">Sort by</label>
                            </div>
                            <div v-else class="input-group-prepend">
                                <label class="input-group-text bg-white filter-box" for="sort-filter">Sort by</label>
                            </div>
                            <select class="d-inline-block flex-grow-1" v-model="resultSort.selected" id="sort-filter">
                                <option v-for="(option, index) in sortOptions" :key="index" :value="option.sort">
                                    <span class="ml-1">{{ option.label }}</span>
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container d-lg-none">
                <div class="col-6 float-right">
                    <button class="btn float-right refine-button" v-b-toggle.sidebar-filter>
                        Refine
                        <svg-icon id="refine-icon" name="sort" width="15" height="auto"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="container mt-4">
            <div v-if="results.length && allResultsRetrieved && !sortedResultItems.length && !resultsAreLoading">
                <h2>No search results</h2>
                <p class="mb-4">Your search returned no results.</p>
                <p>
                    Please consider:
                    <ul>
                        <li>Amending your journey origin/destination</li>
                        <li>Updating your journey date/times</li>
                        <li>Updating any applied filters to provide more options</li>
                    </ul>
                </p>
            </div>
            <results-loading v-if="resultsAreLoading"></results-loading>
            <div class="row results" id="main" role="main">
                <result-item v-for="(result, index) in sortedResultItems" :key="index" :payload="result" :carbon="getCo2" :lowestCarbon="lowestCo2" :highestCarbon="highestCo2" :journey-type="filterAndSortingSwitch ? 'depart' : 'return'" />
            </div>
            <advertising-space></advertising-space>
        </div>
    </div>
</template>

<script>
import ResultItem from '@/components/ResultItem.vue'
import EditJourney from '@/components/EditJourney.vue'
import pusher from '@/broadcasting/app-pusher'
import {
    mapState,
    mapMutations,
    mapActions,
    mapGetters,
} from 'vuex'
import mutationsMapping from '@/store/mutations-mapping'
import { sortOptions } from '@/store/options'
import RefineJourney from '@/components/RefineJourneySideNav.vue'
import ResultsLoading from '@/components/ResultsLoading.vue'
import AdvertisingSpace from '@/components/AdvertisingSpace.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND];

export default {
    name: 'results',
    components: {
        ResultItem,
        EditJourney,
        RefineJourney,
        ResultsLoading,
        AdvertisingSpace,
    },
    data() {
        return {
            sidebarIsOpen: false, // helps re-mount the edit-journey component so it picks up vuex
            resultsCount: 0,
            retrievedResultsCount: 0,
            hash: this.$route.params.hash,
            sortOptions,
            filterAndSortingSwitch: true,
            brand: whitelabel.brand,
            enableMultipleJourneyTypeFilter: whitelabel.enableMultipleJourneyTypeFilter,
        };
    },
    mounted() {
        this.applyQueryFilters()
        this.subscribeToPusherChannel()
    },
    watch: {
        availableJourneyStages(stages) {
            if (this.enableMultipleJourneyTypeFilter && !this.selectedMultipleResultStages.length) {
                this.setMultipleResultStages(stages)
            }
        },
    },
    computed: {
        ...mapState([
            'isLoading',
            'results',
            'searchQuery',
            'resultFilter',
            'resultSort',
            'selectedMultipleResultStages',
        ]),
        ...mapGetters([
            'allResultsRetrieved',
            'filteredResultItems',
            'sortedResultItems',
            'resultFilters',
            'getCo2',
            'availableJourneyStages',
        ]),
        resultsAreLoading() {
            if (this.isLoading) {
                return true
            }
            if (!this.allResultsRetrieved) {
                return true
            }
            return this.resultsCount !== this.retrievedResultsCount
        },
        hasReturnJourney() {
            return this.searchQuery && this.searchQuery.return_time
        },
        lowestCo2() {
            const lowest = this.getCo2[0]
            return lowest
        },
        highestCo2() {
            const highest = this.getCo2[this.getCo2.length - 1]
            return highest
        },
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'retrieveResults',
            'retrieveSingleJourney',
        ]),
        subscribeToPusherChannel() {
            if (!this.allResultsRetrieved) {
                if (this.brand === 'kcc') {
                    // adding tim here to prevent the re-loading of the page for kent where we werte trying to load journeys that were not created by journeyPlanner
                    setTimeout(() => {
                        this.retrieveResults(this.hash);
                    }, 10000);
                } else {
                // Retrieve results immediately if brand does not match
                    this.retrieveResults(this.hash);
                }
            }
            const channel = pusher.subscribe(`query.${this.hash}`)
            channel.bind('results.retrieved', (retrieved) => {
                this.resultsCount = retrieved.journey_count
                /* push to results `resultsCount` times and array of objects */
                this.results.push(...Array(this.resultsCount).fill({ showPlaceholder: true, journey: {} }))
                channel.bind('journey.processed', (data) => {
                    this.retrieveSingleJourney({
                        hash: this.hash,
                        journeyID: data.journeyID,
                    }).then(() => {
                        this.retrievedResultsCount += 1
                    })
                })
            })
        },
        applyQueryFilters() {
            if (this.$route.query.filters) {
                const filters = this.$route.query.filters.split(',')
                if (filters.length) {
                    this.addResultQueryStages(filters)
                }
            }
            if (this.$route.query.sort) {
                this.setResultSort(this.$route.query.sort)
            }
        },
    },
}
</script>

<style lang="scss">


@media (max-width: 767px) { /* Applies to sm (≤767px) and smaller */
    .w-100-mobile {
        width: 100% !important; /* Full width only on mobile */
    }
}
</style>
